var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductForm',{attrs:{"item":_vm.item,"buttonLoading":_vm.buttonLoading},on:{"saveProduct":_vm.saveProduct}})
}
var staticRenderFns = []

export { render, staticRenderFns }